import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

// Define the custom hook
const useApi = (apiFunction, segment = '', params = '', options = {}) => {
	const { isPaginated = false, pageSize = 20 } = options;
	const [data, setData] = useState(isPaginated ? [] : null);
	const [error, setError] = useState(null);
	const [, setPage] = useState(0);
	const [loading, setLoading] = useState(false);
	const [totalPages, setTotalPages] = useState(1);
	const dispatch = useDispatch();

	// Function to fetch data
	const fetchData = useCallback(
		async (newPage = 0, newpParam = params) => {
			setLoading(true);
			dispatch(openLoader());
			setError(null);
			try {
				const updatedParams = isPaginated
					? `${newpParam}&page=${newPage}&size=${pageSize}`
					: newpParam;

				const result = await (segment === ''
					? apiFunction(updatedParams)
					: apiFunction(segment, updatedParams));

				if (isPaginated) {
					setData((prevData) => (newPage === 0 ? result.data : [...prevData, ...result.data])); // Append if newPage > 1
					setTotalPages(result.totalPages || 1);
				} else {
					setData(result);
				}
				//if (result.totalPages) setTotalPages(result.totalPages);
				setPage(newPage);
			} catch (e) {
				setError(e);
			} finally {
				setLoading(false);
				dispatch(closeLoader());
			}
		},
		[apiFunction, segment, params, isPaginated, dispatch, totalPages, pageSize]
	);

	// Initial fetch
	useEffect(() => {
		fetchData();
	}, [fetchData]);

	// Return the data, loading, error, and refetch function
	return { data, error, loading, refetch: fetchData, setPage, totalPages };
};

export default useApi;
